<template>
    <div>
        <div>
            <el-button type="primary" @click="handleClickActivityDialogShow">新建奖励规则</el-button>
        </div>
        <el-table :data="datalist">
            <el-table-column prop="name" label="奖励名称" />
            <el-table-column prop="create_time" label="新建时间" width="100px"/>
            <el-table-column prop="" label="活动有效期" width="170px">
                <template slot-scope="scope">
                    {{ scope.row.start_time }} ~ {{ scope.row.end_time }}
                </template>
            </el-table-column>
            <el-table-column label="发放奖励金额(元)">
                <template slot-scope="scope">
                    {{ formatterMoney(scope.row.amount) }}
                </template>
            </el-table-column>
            <el-table-column label="提现金额(元)" >
                <template slot-scope="scope">
                    {{ formatterMoney(scope.row.amount_withdraw) }}
                </template>
            </el-table-column>
            <el-table-column label="未提现金额(元)">
                <template slot-scope="scope">
                    {{ formatterMoney(scope.row.amount_not_withdraw) }}
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    {{ getStatus(scope.row.status) }}
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="edit-btn-box">
                        <el-button size="mini" type="primary" @click="handleClickDetailShowDialog(scope.row, scope.row.id)">编辑</el-button>
                    </div>
                </template>
            </el-table-column>

        </el-table>
        <page-bar
            ref="pageBar"
            :pageSize="50"
            :pageSizes="pageSizes"
            :currentPageCount="datalist.length"
            @page-changed="loadData"
        ></page-bar>

        <el-dialog :visible.sync="addActivityShow" @close="handleCloseActivityDialog">
            <el-form label-position="right">
                <el-form-item label="奖励名称：" label-width="150px">
                    <el-input v-model="activity.name" :disabled="disabled" style="width: 80%;"></el-input>
                </el-form-item>
                <el-form-item label="奖励规则：" label-width="150px">
                    <el-input v-model="activity.rule" :disabled="disabled" style="width: 80%;"></el-input>
                </el-form-item>
                <el-form-item label="细则文案：" label-width="150px">
                    <el-input v-model="activity.template" :disabled="disabled" type="textarea" style="width: 80%;"></el-input>
                </el-form-item>
                <el-form-item label="有效期：" label-width="150px">
                    <el-date-picker
                        style="width: 80%;"
                        v-model="chooseTimerRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="备注：" label-width="150px">
                    <el-input v-model="activity.remark" :disabled="disabled" type="textarea" style="width: 80%;"></el-input>
                </el-form-item>
                <el-form-item label="状态：" label-width="150px">
                    <el-select v-model="activity.status" size="small" :disabled="disabled">
                        <el-option
                            v-for="(opt, index) in statusOpt1"
                            :key="index"
                            :label="opt.desc"
                            :value="opt.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                    <el-button type="info" size="small" @click="addActivityShow = !addActivityShow">取消</el-button>
                    <el-button type="primary" size="small" @click="handleClickSaveSetting">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/api/request.js'
import PageBar from '../ui/PageBar'
import dateFormat from "@/util/date";
export default {
    components: {
        PageBar
    },
    data(){
        return {
            disabled: false,
            searchData: {},
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            dialogShow: false,
            dialogVisible: false,
            addActivityShow: false,
            datalist: [],
            listItem: {},
            detail: {},
            user_finance_config: {},
            extra: {}, //用户财务配置信息	
            amount_withdraw_monthly_sum: [], //各月份提现金额	
            settlement_records: [], //提现相关结算记录	
            statusOptions: ['有效',  '无效'],
            typeOptions: ['未认证',  '个人用户', '企业用户'],
            statusOpt: [{value: 999, desc: '全部'},{value: 1, desc: '有效'},{value: 2, desc: '无效'}],
            statusOpt1: [{value: 1, desc: '有效'},{value: 2, desc: '无效'}],
            commission_rate: null,
            tax_rate: null,
            financeDialogShow: false,
            financeConfig: {},
            verify: true,
            verifyList: [{label: '通过', value: true}, {label: '失败', value: false}],
            failReasonList: [],
            currentWithdrawId: '',
            filter: {},
            activity: {
                name: '',
                start_time: '',
                end_time: '',
                status: '',
                rule: '',
                template: '',
                remark: ''
            },
            chooseTimerRange: '',
            updateType: false
        }
    },
    created() {
        this.loadData(this.currentRange)
    },
    methods: {
        loadData(range){
            this.currentRange = range
            this.datalist = []
            request.saas
                .post('activity/get_activity_list', { range: range, filter: this.filter })
                .then(res => {
                    this.datalist = res.data.list
                })
        },
        handleClickSaveSetting(){
            
            this.activity.start_time = this.chooseTimerRange[0]
            this.activity.end_time = this.chooseTimerRange[1]
            //console.log(this.activity, this.updateType)
            if(this.updateType) {
                request.saas
                    .post('activity/update_activity', this.activity)
                    .then(() => {
                        this.loadData(this.currentRange)
                        this.$message.success('设置成功')
                        this.addActivityShow = false
                    })
            } else {
                request.saas
                    .post('activity/create_activity', this.activity)
                    .then(() => {
                        this.loadData(this.currentRange)
                        this.$message.success('设置成功')
                        this.addActivityShow = false
                    })
            }
            
        },
        handleClickActivityDialogShow(){
            //新建
            this.activity = {
                name: '',
                start_time: '',
                end_time: '',
                status: '',
                rule: '',
                template: '',
                remark: ''
            }
            this.updateType = false
            this.chooseTimerRange = []
            this.addActivityShow = true
            this.disabled = false
        },
        handleCloseActivityDialog(){
            this.addActivityShow = false
        },
        getStatus(status) {
            return this.statusOptions[status-1]
        },
        formatterMoney(money) {
            return (money/100).toFixed(2)
        },
        handleClickDetailShowDialog(item, id){
            //更新
            if(id === '0') return
            this.updateType = true
            request.saas
                .post('activity/get_activity_info', {id: item.id})
                .then(res => {
                    console.log(res)
                    this.activity = res.data
                    this.chooseTimerRange = [res.data.start_time, res.data.end_time]
                    this.addActivityShow = !this.addActivityShow
                })
        }
    }
}
</script>
<style scoped>
.amountItem{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 10px;
}
.amountItem .el-input{
    margin-left: 20px;
    width: 200px;
}
</style>
